var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBabyNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.303,
    height: 129.958,
    viewBox: "0 0 95.303 129.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28028",
    "data-name": "Path 28028",
    d: "M232.883,111.8,219.9,123.648l10.2,12.39-4.269,9.227a8.975,8.975,0,0,0,4.144,11.837,8.5,8.5,0,0,0,3.713.856,8.687,8.687,0,0,0,7.869-5.092l6.656-14.384A9.05,9.05,0,0,0,247,128.959Zm23.877-29.125c-13.547-8.683-28.075-13.086-43.18-13.086-15.728,0-30.8,4.756-44.784,14.139A8.259,8.259,0,0,0,166.5,95.014a7.921,7.921,0,0,0,6.673,3.68,7.823,7.823,0,0,0,4.368-1.337,71.385,71.385,0,0,1,12.658-6.8,23.3,23.3,0,0,0-.357,4.03v6.259a23.217,23.217,0,0,0,.249,3.39h44.07a23.351,23.351,0,0,0,.248-3.39V94.59a23.23,23.23,0,0,0-.6-5.224,69.39,69.39,0,0,1,14.473,7.118,7.873,7.873,0,0,0,10.991-2.575,8.255,8.255,0,0,0-2.519-11.234ZM212.13,63.225A17.617,17.617,0,1,0,194.9,45.612,17.444,17.444,0,0,0,212.13,63.225Zm-19.924,47.806c.086.174.171.348.26.519l-13.718,16.669a9.047,9.047,0,0,0-1.207,9.525l6.655,14.383a8.685,8.685,0,0,0,7.869,5.092,8.486,8.486,0,0,0,3.713-.857,8.977,8.977,0,0,0,4.145-11.837l-4.27-9.225,10.1-12.267Z",
    transform: "translate(-165.194 -28)",
    fill: "#6b7786",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyNotFound);
export default __webpack_public_path__ + "static/media/baby-not-found.521eb2b601faadc6733b9f46fb55edd4.svg";
export { ForwardRef as ReactComponent };